import React from 'react';
import Modal from '../../Common/Modal/Modal';

interface ChangeDaysOutTask {
    targetDaysOut: number;
    startDaysOut?: number | null;
}

interface ChangeDaysOutModalProps {
    task: ChangeDaysOutTask;
    deltaDays: number;
    onCancel: () => void;
    onComplete: () => void;
}

const ChangeDaysOutModal: React.FC<ChangeDaysOutModalProps> = ({ task, deltaDays, onCancel, onComplete }) => {
    const renderBody = () => (
        <div>
            <div>Are you sure you want to change the Target Days Out from {task.targetDaysOut} to {(deltaDays * -1) + task.targetDaysOut}?</div>
            {task.startDaysOut &&
                <div>Are you sure you want to change the Start Days Out from {task.startDaysOut} to {(deltaDays * -1) + task.startDaysOut}?</div>
            }
        </div>
    );

    return (
        <Modal
            id="ChangeDaysOutModal"
            title="Confirm Change"
            body={renderBody()}
            onCloseClick={onCancel}
            onPrimaryClick={onComplete}
            onSecondaryClick={onCancel}
        />
    );
};

export default ChangeDaysOutModal;
